import React, { Component, useEffect, useState } from 'react';
import { Button, message } from 'antd';
import PaginatedTable from '../../commonComponents/PaginatedTable';
import { useGetAllPIIOfOrder } from '../../hooks/useOrders';
import './style.scss';
import useLogout from '../../hooks/useLogout';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import MappingBox from './MappingBox';

export default function DraftPiiList({ searchName, setSearchName }) {
    const [piiList, setPiiList] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedPii, setSelectedPii] = useState(null);
    const { logout } = useLogout();

    const OnChangePaginator = (page, size) => {
        if (Number(pageNum) !== page) {
            setPageNum(page);
        } else {
            setPageNum(page);
            setPageSize(size);
        }
    };

    const onSuccessPIIFetch = data => {
        if (data?.data?.data && data?.data?.data?.length > 0) {
            setPiiList(data?.data?.data);
            setTotalCount(data?.data?.totalCount);
        } else {
            setPiiList([]);
            setTotalCount(0);
        }
    };

    const onErrorPIIFetch = err => {
        // pending
        message.error(err?.response?.data?.message || 'Error');
        if (err?.response?.status === 401) logout();
    };

    const {
        data: piiDraftsDetail,
        refetch: refetchPiiDrafts,
        isFetching: isFetchingPiis,
        isFetched: isFetchedPiis,
    } = useGetAllPIIOfOrder(pageNum, pageSize, searchName, onSuccessPIIFetch, onErrorPIIFetch);

    return (
        <>
            <PaginatedTable
                height={`calc(100vh - 170px)`}
                Footer={null}
                OnChangePaginator={OnChangePaginator}
                columns={[
                    {
                        title: 'Box Name',
                        key: 'boxName',
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.boxName || ''}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Tracking Number',
                        key: 'trackingNumber',
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.identifier?.trackingNumber || ''}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Created By',
                        key: 'createdBy',
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.createdBy?.name || ''}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Created At',
                        key: 'createdAt',
                        render: (_, record) => {
                            return (
                                <>
                                    <div>
                                        {record?.createdAt
                                            ? new Date(record.createdAt).toLocaleDateString('en-GB', {
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric',
                                              })
                                            : ''}
                                    </div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Action',
                        key: 'action',
                        render: (_, record) => {
                            return (
                                <>
                                    {' '}
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                setSelectedPii(record);
                                            }}
                                            style={{ margin: '0 5px' }}
                                            disabled={!!record?.pendingCount?.length}
                                        >
                                            Assign Box
                                        </Button>
                                    </div>
                                </>
                            );
                        },
                    },
                ]}
                dataSource={piiList}
                isFetching={isFetchingPiis}
                total={totalCount}
                defaultPageSize={20}
                key={'PIITable'}
                pageNum={pageNum}
                pageSize={pageSize}
            />

            {!!selectedPii && (
                <DynamicModal
                    open={!!selectedPii}
                    closable={true}
                    width={'80%'}
                    title={<h4>Assign Box To Draft PII </h4>}
                    close={() => {
                        setSelectedPii(null);
                        refetchPiiDrafts();
                    }}
                    height={'450px'}
                    component={
                        <>
                            <MappingBox selectedPii={selectedPii} setSelectedPii={setSelectedPii} refetchPiiDrafts={refetchPiiDrafts} />
                        </>
                    }
                />
            )}
        </>
    );
}
